import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"],
  _excluded2 = ["size"];
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
/**
 * Creates a feature flagged component that renders the legacy logo or the new logo
 * based on the platform-logo-rebrand feature flag.
 *
 * @param LegacyComponent - The legacy logo component.
 * @param NewComponent - The new logo component.
 * @returns A feature flagged component that renders the legacy logo or the new logo.
 */
export var createFeatureFlaggedComponent = function createFeatureFlaggedComponent(LegacyComponent, NewComponent) {
  // Note: textColor and iconColor aren't supported on all new logos
  // These props will be deprecated in the future
  return function (_ref) {
    var size = _ref.size,
      props = _objectWithoutProperties(_ref, _excluded);
    if (fg('platform-logo-rebrand')) {
      // Size defaults need to be set, as the temp library had different defaults
      return /*#__PURE__*/React.createElement(NewComponent, _extends({
        size: size || 'medium'
      }, props));
    }
    return /*#__PURE__*/React.createElement(LegacyComponent, _extends({
      size: size
    }, props));
  };
};

/**
 * Creates a wrapper around the new logo or icon component to ensure it receives the correct default (medium) size prop.
 *
 * @param NewComponent - The new logo or icon component.
 */
export var tempSizeWrapper = function tempSizeWrapper(NewComponent) {
  return function (_ref2) {
    var size = _ref2.size,
      props = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/React.createElement(NewComponent, _extends({
      size: size || 'medium'
    }, props));
  };
};

// Logos that only exist in @atlaskit/logo
export var LEGACY_ONLY_LOGOS = ['atlassian', 'atlassian-analytics', 'atlas', 'atlassian-marketplace', 'atlassian-access', 'atlassian-administration', 'atlassian-admin', 'jira-align', 'jira-software', 'jira-work-management', 'loom-attribution'];

// Logos that exist in both packages
export var SHARED_LOGOS = ['bitbucket', 'compass', 'confluence', 'jira', 'jira-product-discovery', 'jira-service-management', 'loom', 'opsgenie', 'statuspage', 'trello', 'rovo', 'guard', 'focus'];

// Logos that only exist in @atlaskit/temp-nav-app-icons
export var NEW_ONLY_LOGOS = ['admin', 'align', 'analytics', 'assets', 'chat', 'company-hub', 'goals', 'guard-detect', 'home', 'projects', 'search', 'studio', 'talent', 'teams'];